import { IconProps } from '@/components/Icons/types/IconInterface';
import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';

const ChevronRightIcon = ({ size, variant, className }: IconProps) => {
  return (
    <svg
      className={cn(iconVariant({ variant, size, className }))}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2803 11.4697C16.5732 11.7626 16.5732 12.2374 16.2803 12.5303L8.78033 20.0303C8.48744 20.3232 8.01256 20.3232 7.71967 20.0303C7.42678 19.7374 7.42678 19.2626 7.71967 18.9697L14.6893 12L7.71967 5.03033C7.42678 4.73744 7.42678 4.26256 7.71967 3.96967C8.01256 3.67678 8.48744 3.67678 8.78033 3.96967L16.2803 11.4697Z"
        fill="#010F55"
      />
    </svg>
  );
};

export default ChevronRightIcon;
